import { render } from "./AdmButton.vue?vue&type=template&id=545c1fcd&scoped=true"
import script from "./AdmButton.vue?vue&type=script&lang=js"
export * from "./AdmButton.vue?vue&type=script&lang=js"

import "./AdmButton.vue?vue&type=style&index=0&id=545c1fcd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-545c1fcd"]])

export default __exports__